import React from 'react'

import { createValidIcon } from '@ui/icons/utils/type-helper'

export const CircleCloseIcon = createValidIcon((props) => {
  const { size, color } = props

  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill={color}
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4ZM14.293 8.29297C14.6835 7.90251 15.3165 7.90247 15.707 8.29297C16.0975 8.68348 16.0975 9.31652 15.707 9.70703L13.4141 12L15.707 14.293C16.0974 14.6835 16.0975 15.3166 15.707 15.707C15.3166 16.0975 14.6835 16.0974 14.293 15.707L12 13.4141L9.70703 15.707C9.31652 16.0975 8.68348 16.0975 8.29297 15.707C7.90247 15.3165 7.90251 14.6835 8.29297 14.293L10.5859 12L8.29297 9.70703C7.90244 9.31651 7.90244 8.68349 8.29297 8.29297C8.68349 7.90244 9.31651 7.90244 9.70703 8.29297L12 10.5859L14.293 8.29297Z'
        fill={color}
      />
    </svg>
  )
})
